interface FooterContact {
  id: number;
  text: string;
  url: string;
}

const Footer: React.FC = () => {
  const footerContact: FooterContact[] = [
    { id: 1, text: "contact@sweptbooks.com", url: "mailto:contact@sweptbooks.com" },
    { id: 2, text: "682-325-8108", url: "tel:6823258108" },
    { id: 3, text: "LinkedIn", url: "https://www.linkedin.com/in/vladimir-lam%C3%A9rique-25b562316/" },
  ];

  return (
    <>
      <footer className="sb-footer">

        {/* CTA block */}
        <div className="sb-footer-cta">
          <h4 className="sb-footer-headline">
            Focus on what you do best — I'll handle the rest.
          </h4>
          <p className="sb-footer-subtext">
            Beyond bookkeeping — comprehensive financial support for small
            businesses. From inventory management to payroll, I've got you covered.
          </p>
          <a
            href="https://calendly.com/contact-sweptbooks/30min"
            target="_blank"
            rel="noreferrer"
            className="sb-footer-btn"
          >
            Schedule today
          </a>
        </div>

        {/* Bottom bar */}
        <div className="sb-footer-bottom">
          <p className="sb-footer-bottom-text">
            Bookkeeping and payroll made simple. Sign up, connect your banks,
            and get back to work.
          </p>
          <ul className="sb-footer-contact">
            {footerContact.map((contact) => (
              <li key={contact.id}>
                <a href={contact.url}>{contact.text}</a>
              </li>
            ))}
          </ul>
          <p className="sb-footer-copy">© 2026 SweptBooks</p>
        </div>

      </footer>
    </>
  );
};

export default Footer;